var _defs, _circle, _circle2, _circle3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavMissionIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 186.3 186.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 8.34px;\n      }\n\n      .cls-2 {\n        fill: #f4c256;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 69.98,
    cy: 116.31,
    r: 65.82
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 69.98,
    cy: 116.31,
    r: 42.51
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 69.98,
    cy: 116.31,
    r: 19.17
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "143.31 42.46 118.5 67.27 121.85 28.98 146.66 4.17 143.31 42.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "157.32 64.44 182.13 39.63 143.83 42.98 119.02 67.79 157.32 64.44"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.98,
    y1: 116.31,
    x2: 144.14,
    y2: 42.16
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavMissionIconBlack);
export default __webpack_public_path__ + "static/media/nav-mission-icon-black.f3efe2b6b1540c83fbee239e7a2cb787.svg";
export { ForwardRef as ReactComponent };